import Rails from '@rails/ujs'
import axios from "axios";

export default class Notes {
  constructor(base_url) {
    this.base_url = base_url
    this.data = {
      notes: []
    }
  }

  call () {
    // this.wrapperNotes.innerHTML = this.templateNotes.innerHTML
    this.getData()
  }

  getData() {
    let url = this.base_url + '/show_data?data_type=notes'

    Rails.ajax({
      type: "GET",
      url: url,
      success: this.successResponse.bind(this)
    })
  }

  successResponse(response) {
    this.data = response
    this.wrapperNotes.innerHTML = this.parseTemplate()
    this.wrapperNoteListSize.innerHTML = ''
    // response.notes.forEach((element) => {
    //   this.addItem(element)
    // });
  }

  parseTemplate () {
    _.templateSettings = {
      evaluate:    /\{\{(.+?)\}\}/g,
      interpolate: /\{\{=(.+?)\}\}/g,
      escape:      /\{\{-(.+?)\}\}/g
    }

    let compiled = _.template(this.templateNotes.innerHTML)

    return compiled(this.data)
  }

  // addItem(element) {
  //   this.wrapperTemplateNoteItem.insertAdjacentHTML( 'afterbegin', this.parseItem(element) );
  // }

  // parseItem(item) {
  //   _.templateSettings = {
  //     evaluate:    /\{\{(.+?)\}\}/g,
  //     interpolate: /\{\{=(.+?)\}\}/g,
  //     escape:      /\{\{-(.+?)\}\}/g
  //   }

  //   let compiled = _.template(this.templateNoteItem.innerHTML)

  //   return compiled(item)
  // }

  removeNote (element) {
    let url = this.base_url + '/notes/' + element.dataset.noteId;
    axios({
      headers: { 'Content-Type': 'application/json' },
      method: 'DELETE',
      url: url
    }).then(response => {
      if (response.data.success) {
        document.getElementById('wrapper-note-' + response.data.note_id).remove();
      }
    })
  }

  submitNote (element) {
    let url = this.base_url + '/notes';

    Rails.ajax({
      type: 'POST',
      url: url,
      data: Rails.serializeElement(element),
      success: (response) => {
        this.successResponse(response)
        // this.addItem(response)
        document.getElementById('note-description').value = ''
      },
      error: (response) => {

      }
    })
  }

  submitEditNote(element) {
    let url = this.base_url + '/notes/' + element.dataset.noteId;

    Rails.ajax({
      type: 'PUT',
      url: url,
      data: `note%5Bdescription%5D=${encodeURIComponent(document.querySelector('#edit-note-description').value)}`,
      success: (response) => {
        this.successResponse(response)
      },
      error: (response) => {
      }
    })
  }

  get wrapperNotes() {
    return document.getElementById('wrapper-notes')
  }

  get templateNotes() {
    return document.getElementById('template-notes')
  }

  // get templateNoteItem() {
  //   return document.getElementById('template-note-item')
  // }

  // get wrapperTemplateNoteItem () {
  //   return document.getElementById('template-note-item-wrapper')
  // }

  get wrapperNoteListSize () {
    return document.getElementById('note_list_size')
  }
}